import { Component, Input, inject } from '@angular/core';
import { NotificationCenterService } from '../notification-center.service';
import { ISockets } from '../notification-center.interface';
import { Router } from '@angular/router';
import { CustomUserFlowService } from '../../../../services/custom-user-flow.service';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { AsyncPipe } from '@angular/common';
import { SafePipe } from '../../../pipes/safe.pipe';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  imports: [AsyncPipe, TranslatePipe, SafePipe, SafePipe],
})
export class NotificationItemComponent {
  notifyService = inject(NotificationCenterService);
  customFlow = inject(CustomUserFlowService);
  private _router = inject(Router);


  @Input() notify: ISockets | any;

  async navigateByRoute(route: string | any, params?: any) {
    if (params) {
      await this._router.navigate(route, { queryParams: params });
    } else {
      await this._router.navigateByUrl(route);
    }
    this.notifyService.toggle();
  }
}
